var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"router-fade","mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),(_vm.isWx)?_c('div',{staticClass:"mask_wx"},[_c('img',{attrs:{"src":require("./images/mask_wx.png"),"alt":""}})]):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-136440c8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 